var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"tag-1024-11"},[_c('div',{staticClass:"x029-92 plusjakartasans-bold-granite-gray-14px"},[_vm._v(_vm._s(_vm.x029))]),_c('fee2',{attrs:{"number":_vm.fee2Props.number,"className":_vm.fee2Props.className}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }